import { logger } from '@gem/modules/logger';

import { ICalendarEventUpdate, CalendarRealtimeAction } from 'APP/model/calendar/calendar.types';
import EventBus from 'APP/packages/bus';

export async function handleCalendarEventUpdate(data: ICalendarEventUpdate): Promise<void> {
  if (!data.event) {
    return;
  }

  switch (data.action) {
    case CalendarRealtimeAction.DELETE: {
      EventBus.calendar.broadcastDeleteCalendarEvent(data.event);
      break;
    }
    case CalendarRealtimeAction.UPDATE: {
      EventBus.calendar.broadcastUpdateCalendarEvent(data.event);
      break;
    }
    case CalendarRealtimeAction.CREATE: {
      EventBus.calendar.broadcastCreateCalendarEvent(data.event);
      break;
    }
    default: {
      logger.log('Unknown action from calendar realtime event');
      break;
    }
  }
}
